import { busesAPI } from "components/Apis/Buses";
import { apiUrl } from "config";
import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";

export const BOLPrinter = ({ order = null, bus = null, size = "m-1 px-2 py-1", btnClass=null }) => {
    const [showStopSelection, setShowStopSelection] = useState(false);
    const [stops, setStops] = useState([]);

    if (order) {
        var link = `${apiUrl}print/bol/order/${order.id}`
    }
    else if (bus) {
        var link = `${apiUrl}print/bol/bus/${bus.id}`
    } else {
        toast.error("No order or bus provided to print BOL");
    }

    const handlePrintBOL = (e) => {
        if (bus) {
            busesAPI.getStops(bus.id).then((response) => {
                if (response.length <= 1) {
                    e.stopPropagation();
                    window.open(link, "_blank");
                }
                else {
                    setStops(response);
                    setShowStopSelection(true);
                }
                console.log(response);
    
            }).catch((error) => {
                toast.error(`${error.response?.data?.msg || error.message}`);
            });
        }

        else if (order) {
            e.stopPropagation();
            window.open(link, "_blank");
        }
    };

    return (
        <>
            <button
                className={btnClass ? btnClass : `btn btn-primary ${size ? size : ""}`}
                onClick={(e) => handlePrintBOL(e)}
                title="Print BOL"
            >
                <i className="fa fa-print"></i>
            </button>
            <Modal show={showStopSelection} onHide={() => setShowStopSelection(false)} className="warehouse-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Print BOL</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>This bus has more than one stop! Which one do you want to print?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="button"
                        onClick={setShowStopSelection.bind(this, false)}
                    >
                        Close
                    </button>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                        }}
                    >
                        {stops.map((stop) => (
                            <button
                                key={stop.id}
                                className="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const params = new URLSearchParams({
                                        stop_id: stop.id,
                                        ref: "dashboard",
                                        timestamp: Date.now(),
                                    });
                                    window.open(`${link}?${params.toString()}`, "_blank");
                                }}
                            >
                                {stop.name}
                            </button>
                        ))}
                        <button
                            className="button"
                            onClick={() => {
                                window.open(link, "_blank");
                            }}
                        >
                            Print All
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};